<template>
  <md-table-row
    :class="{
      'table-info': value.label.toLowerCase() == 'magic price',
      'table-info': value.editable == true,
    }"
  >
    <md-table-cell class="h6 first-row" :title="value.label">
      <md-checkbox
        v-if="value.editable"
        class="m-0 checkbox-edited-by-user"
        style="position: relative; padding: 0; padding-right: 5px; transform: translateY(3px);"
        @change="toggleRow($event)"
        v-model="value.selected"
      ></md-checkbox>

      {{ value.label }}

      <span style="display: block; font-size: 10px;">({{ value.sub_label }})</span>
      <span style="display: block; font-size: 10px;">({{ value.physical_rooms }})</span>
    </md-table-cell>

    <md-table-cell v-for="(cell, index) in visibleColumns" :key="'cell_' + index" md-label="ID" class="bg-open">
      <template v-if="value.editable">
        <pricing-table-editable-element
          :ref="'channel-editable-' + value.label.toLowerCase()"
          :value="cell.value.price"
          :symbol="simbol"
          :room-type-id="value.room_type_id"
          :value-format="value.value_format"
          @change="pricingSelected($event, cell.key, value.room_type_id)"
        >
        </pricing-table-editable-element>

        <allotment-indicator
          v-if="value.editable && !!cell.value.allotment"
          :value="cell.value.allotment"
          :room-type-id="value.room_type_id"
          @change="allotmentSelected($event, cell.key, value.room_type_id)"
        ></allotment-indicator>
      </template>
    </md-table-cell>
  </md-table-row>
</template>

<script>
/*eslint-disable */

import AllotmentIndicator from '../Allotment/AllotmentIndicator.vue'
import PricingTableEditableElement from './PricingTableEditableElement.vue'
import PricingTableNonHideableRow from './PricingTableNonHideableRow.vue'
import Currency from '@/utils/Currency'

export default {
  components: {
    PricingTableEditableElement,
    PricingTableNonHideableRow,
    AllotmentIndicator,
  },
  name: 'PricingTableRow',
  props: {
    value: Object,
  },
  data() {
    return {}
  },
  methods: {
    toggleRow(selected) {
      this.value.data.forEach((element) => {
        const actual = element.value.price
        this.$set(actual, 'is_selected', selected)
        this.pricingSelected(selected, element.key, this.value.room_type_id)
      })
    },
    toFixedTrunc(figure, decimals) {
      if (!decimals) decimals = 2

      var d = Math.pow(10, decimals)

      return (parseInt(figure * d) / d).toFixed(decimals)
    },
    allotmentSelected: function(isSelected, travelDate, roomTypeId) {
      this.$emit('allotmentSelected', isSelected, travelDate, roomTypeId)
    },
    pricingSelected: function(isSelected, travelDate, roomTypeId) {
      this.$emit('pricingSelected', isSelected, travelDate, roomTypeId)
    },
  },
  computed: {
    visibleColumns() {
      return this.value.data
    },
    simbol() {
      if (this.value.symbol.indexOf('€') >= 0) {
        return this.value.symbol.replace('€', Currency[sessionStorage.getItem('currency')])
      } else {
        return this.value.symbol
      }
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/md/_variables.scss';

.md-table-cell .md-checkbox {
  zoom: 0.7;
  margin: 0;
}
.md-table-cell {
  width: 120px !important;
}

.allotment-cell-container {
  width: 100%;
  margin: 0 auto;
  max-width: 120px;
}

.md-table .md-table-row:hover .md-table-cell.bg-open,
.bg-open {
  background-color: white !important;
}

.md-table .md-table-row:hover .md-table-cell.bg-closed,
.bg-closed {
  background: repeating-linear-gradient(#f2d7b4, #f2d7b4) !important;
}

.md-table .md-table-row:hover .md-table-cell.bg-partial,
.bg-partial {
  background: repeating-linear-gradient(45deg, rgb(247, 231, 209) 10px, rgb(252, 246, 238) 10px, rgb(242, 215, 180) 20px) !important;
}
.md-table .md-table-row:hover .md-table-cell.bg-saved,
.bg-saved {
  background: repeating-linear-gradient($brand-saved, $brand-saved) !important;
}

.is-non-dirty {
  &.future-open .future-selected {
    background: rgb(76, 175, 80);
  }
  &.future-close .future-selected {
    background: #f44336;
  }
}
</style>
}
